/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/no-unused-vars */
import LocalizedDate from "components/shared/LocalizedDate";
import Text from "hardcover-ui/components/Text";
import TextLink from "hardcover-ui/components/TextLink";
import { oxfordCommaList, topTags } from "lib/array";
import { roundRating } from "lib/numberUtils";
import pluralize from "lib/pluralize";
import { PageSerializersAuthorsLayout } from "types/serializers";

export default function AuthorBio({ author }: { author: PageSerializersAuthorsLayout }) {
  const bio = [];

  if (author.bornYear && author.deathYear) {
    bio.push(
      `${author.name} was born in ${author.bornYear} and died in ${author.deathYear}.`
    );
  } else if (author.bornYear) {
    bio.push(`${author.name} was born in ${author.bornYear}`);
  } else if (author.deathYear) {
    bio.push(`${author.name} died in ${author.deathYear}`);
  }

  bio.push(
    `${
      author.name
    } has written at least ${author.booksCount.toLocaleString()} ${pluralize(
      "book",
      author.booksCount
    )}.`
  );

  const text = bio.join(", ");
  return (
    <Text variant="secondary" as="p">
      {text}
      {author.popularBook && (
        <>
          {" "}
          Their most popular book is{" "}
          <TextLink href={`/books/${author.popularBook.slug}`}>
            {author.popularBook.title}
          </TextLink>{" "}
          with {author.popularBook.usersCount}{" "}
          {pluralize("save", author.popularBook.usersCount)} with an average rating of{" "}
          {roundRating(author.popularBook.rating, 2)}⭐.
        </>
      )}
      {author.genres.length > 0 && (
        <>
          <br />
          <br />
          They are best known for writing in the{" "}
          {pluralize("genre", author.genres.length)} {oxfordCommaList(author.genres)}.
        </>
      )}
      {author.moods.length > 0 && (
        <>
          <br />
          <br />
          {oxfordCommaList(author.moods)} {author.moods.length > 1 ? "are" : "is"} their most
          common moods.
        </>
      )}
      {author.nextBook && (
        <>
          {" "}
          Their next book,{" "}
          <TextLink href={`/books/${author.nextBook.slug}`}>
            {author.nextBook.title}
          </TextLink>
          , is scheduled for release on{" "}
          <LocalizedDate date={String(author.nextBook.releaseDate)} />.
        </>
      )}
    </Text>
  );
}